import React from 'react';
import { MenuItem } from '@mui/material';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';

import * as S from './styled';

const SelectSite = ({ options, onChange, value, label, ...props }) => {
  return (
    <S.FormControlBlock>
      <InputLabel>{label}</InputLabel>
      <S.StyledSelectSite
        displayEmpty={true}
        value={value}
        input={<OutlinedInput label={label} />}
        onChange={onChange}
        {...props}>
        {options.map((el, i) => {
          return (
            <MenuItem 
            key={i + el.value + el.name} 
            value={el.value} 
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
          >
            <span>{el.name}</span>
            <span style={{ fontSize: '0.85em', color: '#999', marginLeft: 'auto' }}>
              &nbsp;[{el.value}]
            </span>
          </MenuItem>
          );
        })}
      </S.StyledSelectSite>
    </S.FormControlBlock>
  );
};

export default SelectSite;
